import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { heroImage } from "@/mocks/anime";

const stats = [
  { value: "4", label: "核心栏目" },
  { value: "200+", label: "原创内容" },
  { value: "1.8w+", label: "同好成员" },
];

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(`/recommend?q=${encodeURIComponent(keyword.trim())}`);
  };

  return (
    <section className="relative flex min-h-[560px] w-full items-center justify-center overflow-hidden md:min-h-[640px]">
      <img
        src={heroImage}
        alt="新御宅屋动漫同好社区首屏插画"
        title="新御宅屋求番推荐与补番顺序社区"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-foreground-950/60"></div>

      <div className="container-x relative z-10 w-full py-24 md:py-28">
        <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/15 px-4 py-1.5 text-xs font-bold text-background-50 backdrop-blur">
            <i className="ri-fire-line text-accent-400"></i>
            求番推荐 · 避雷指南 · 补番顺序 · 同好交流
          </span>

          <h1 className="mt-6 font-heading text-3xl leading-tight text-background-50 sm:text-4xl md:text-5xl">
            新御宅屋 · 动漫同好一站到底
          </h1>
          <p className="mt-4 max-w-2xl text-sm leading-7 text-background-50/90 md:text-base">
            不知道下一部看什么？想按顺序补完老番？在这里求番推荐、查私藏安利、翻避雷指南、参与漫评讨论。
            同好都在，来问、来翻、来聊。
          </p>

          <form
            onSubmit={handleSubmit}
            className="mt-8 flex w-full max-w-xl items-center gap-2 rounded-full border border-background-50/25 bg-background-50/95 p-2 backdrop-blur"
          >
            <i className="ri-search-line pl-3 text-lg text-foreground-500"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="输入你想看的类型，例如：热血、治愈、悬疑……"
              className="h-10 flex-1 bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-500"
              aria-label="搜索想看的番剧类型"
            />
            <button
              type="submit"
              className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors duration-200 hover:bg-primary-600"
            >
              去求番
            </button>
          </form>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Link to="/recommend" className="btn-primary">
              立即求番推荐
            </Link>
            <Link
              to="/avoid"
              className="inline-flex items-center justify-center whitespace-nowrap rounded-full border-2 border-background-50/60 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors duration-200 hover:bg-background-50 hover:text-foreground-800"
            >
              查避雷指南
            </Link>
          </div>

          <dl className="mt-12 grid w-full max-w-md grid-cols-3 gap-4">
            {stats.map((s) => (
              <div key={s.label} className="flex flex-col items-center gap-1">
                <dd className="font-latin text-2xl font-extrabold text-accent-300 md:text-3xl">{s.value}</dd>
                <dt className="text-xs text-background-50/80">{s.label}</dt>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}